import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../services';
import { FormGroup } from '@angular/forms';
import { AttachmentsService } from '@pt/api-client';
import { Subject } from 'rxjs';
import { Directive, EventEmitter, OnDestroy, Output } from '@angular/core';
import { AttachFileDialogResponse } from '@pt/pt-models';
import { Attachment } from 'it/primatoo/openapi/api/org/schemas/common/Attachment';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { TimeUtils } from '@pt/pt-core';

@Directive()
export abstract class CreateUpdateFormComponent implements OnDestroy {
  @Output() downloadAttachment: EventEmitter<Attachment> =
    new EventEmitter<Attachment>();
  currentHelpValue: string = null;
  currentNoteValue: string = null;

  formGroup: FormGroup;
  showAttachError = false;
  protected destroy$ = new Subject<boolean>();
  public toDay: NgbDate = TimeUtils.getTomorrow();

  protected constructor(
    public attachmentsService: AttachmentsService,
    public translateService: TranslateService,
    public dialogService: DialogService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  changeHelpValue($event: string) {
    if (
      this.formGroup &&
      this.formGroup?.contains('help') &&
      this.currentHelpValue !== $event
    ) {
      this.formGroup.controls.help.setValue($event);
      this.formGroup.updateValueAndValidity();
      this.formGroup.markAsTouched();
      this.currentHelpValue = $event;
    }
  }

  changeNotesValue($event: string) {
    if (
      this.formGroup &&
      this.formGroup?.contains('notes') &&
      this.currentNoteValue !== $event
    ) {
      this.formGroup.controls.notes.setValue($event);
      this.formGroup.updateValueAndValidity();
      this.formGroup.markAsTouched();
      this.currentNoteValue = $event;
    }
  }

  onAttachAction($event: AttachFileDialogResponse): void {
    const current: Attachment[] =
      this.formGroup.controls?.attachments?.value ?? [];
    this.showAttachError = false;
    this.formGroup.controls.attachments.setValue([...current, $event.data]);
    this.formGroup.updateValueAndValidity();
    this.formGroup.markAsTouched();
  }

  onDeleteAttachment(attachment: Attachment) {
    const filteredAttachments: Attachment[] =
      this.formGroup.controls.attachments.value;
    this.formGroup.controls.attachments.setValue(
      filteredAttachments.filter((a) => a?.id !== attachment?.id)
    );
    this.formGroup.updateValueAndValidity();
    this.formGroup.markAsTouched();
  }

  onDownloadAttachment(attachment: Attachment) {
    this.downloadAttachment.emit(attachment);
  }

  setFormInvalid(value: boolean) {
    value
      ? this.formGroup.setErrors({ invalid: true })
      : this.formGroup.setErrors(null);
  }

  public setUntouched() {
    this.formGroup?.markAsUntouched();
  }

  reset() {
    this.formGroup?.reset();
    this.currentHelpValue = null;
    this.currentNoteValue = null;
    this.resetCustom();
  }

  abstract resetCustom(): void;
}
